import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedaSelect } from 'sharedComponents/select'

const MonedaFormGroup = ({ iError, iTouched, iValue, fIsSubmitting, flagEditarComentarios, flagGrifo }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={flagGrifo ? 6 : 4} alignRightAt='md' />
      <Col md={flagGrifo ? 6 : 8}>
        <Field name='moneda'>
          {({ field }) => (
            <MonedaSelect {...field} disabled={fIsSubmitting || flagEditarComentarios} isInvalid={iTouched && iError} id='select-moneda' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
